import { SPRest } from "../rest.js";
import { Utilities } from "./types.js";
export { Utilities, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "utility", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return Utilities(baseUrl, "").configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map